export const transformStatus = {
    "Ready to build": "RTB",
    "Notice to Proceed": "NTP",
    "COD": "COD",
    "Early Stage": "Early Stage",
    "In operation": "In operation",
    "Advanced Development": "Advanced Dev"
}

export function formatFloat(value) {
    const num = Number(value);
    if (isNaN(num)) return '-';

    if (Number.isInteger(num)) {
        return num.toLocaleString('es-ES');
    }

    // Si tiene decimales, formatea con hasta 2 cifras decimales
    return num.toLocaleString('es-ES', { minimumFractionDigits: 2 });
}

